// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1dKOj","title":"Header_title__1Nv_B","side":"Header_side__3yo3R"};